<template>
  <div class="ProspectAvatar">
    <div class="ProspectAvatar__image-wrapper">
      <ImageLoader
        :large="large"
        :small="small"
        class="ProspectAvatar__image"
        empty-picture="profile"
        :file="image"
      ></ImageLoader>
    </div>
    <div class="ProspectAvatar__hover-backplate"></div>
    <div v-if="slots.rightIndicator" class="ProspectAvatarIndicator ProspectAvatar__indicator_right">
      <div class="ProspectAvatarIndicator__content">
        <slot name="indicator-right"></slot>
      </div>
    </div>
    <div v-if="slots.leftIndicator" class="ProspectAvatarIndicator ProspectAvatar__indicator_left">
      <div class="ProspectAvatarIndicator__content">
        <slot name="indicator-left"></slot>
      </div>
    </div>
    <div
      v-if="slots.bottomRightIndicator"
      class="ProspectAvatarIndicator ProspectAvatar__indicator_right-bottom"
    >
      <div class="ProspectAvatarIndicator__content">
        <slot name="indicator-right-bottom"></slot>
      </div>
    </div>
    <div
      v-if="slots.bottomLeftIndicator"
      class="ProspectAvatarIndicator ProspectAvatar__indicator_left-bottom"
    >
      <div class="ProspectAvatarIndicator__content">
        <slot name="indicator-left-bottom"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { ProspectModel } from '@/models/prospect'

import ImageLoader from '@/components/common/ImageLoader/ImageLoader.vue'
export default {
  name: 'ProspectAvatar',
  components: {
    ImageLoader
  },
  props: {
    prospect: { type: ProspectModel, required: true },
    large: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    disableTooltip: { type: Boolean, default: false },
    disableNewSmsIndicator: { type: Boolean, default: false }
  },
  data() {
    return {
      slots: {
        bottomRightIndicator: false,
        bottomLeftIndicator: false,
        rightIndicator: false,
        leftIndicator: false
      }
    }
  },
  computed: {
    image() {
      return this.prospect.image
    }
  },
  created() {
    this.setShowSlots()
  },
  beforeUpdate() {
    this.setShowSlots()
  },
  methods: {
    setShowSlots() {
      this.slots.rightIndicator = !!this.$slots?.['indicator-right']?.[0]
      this.slots.leftIndicator = !!this.$slots?.['indicator-left']?.[0]
      this.slots.bottomRightIndicator = !!this.$slots?.['indicator-right-bottom']?.[0]
      this.slots.bottomLeftIndicator = !!this.$slots?.['indicator-left-bottom']?.[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.ProspectAvatar {
  @apply w-full h-full relative;
  $root: &;

  &__popper {
    @apply w-full h-full;
  }
  ::v-deep {
    #{$root}__popper-trigger {
      @apply w-full h-full;
    }
  }

  &__hover-backplate {
    @apply w-full h-full rounded-full absolute top-0 left-0 pointer-events-none;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
    @apply opacity-0 transition duration-200;
  }
  &__image-wrapper {
    @apply w-full h-full absolute overflow-hidden rounded-full;
    /*&_disabled {
      @apply cursor-default;
    }
    &:not(#{$root}__image-wrapper_disabled) {
      &:hover {
        #{$root}__image {
          transform: scale(1.3);
        }
        ~ #{$root}__hover-backplate {
          @apply opacity-100;
        }
      }
      &:focus-visible {
        #{$root}__image {
          transform: scale(1.3);
        }
        ~ #{$root}__hover-backplate {
          @apply opacity-100;
        }
      }
      &:active {
        #{$root}__image {
          transform: scale(1.2);
        }
        ~ #{$root}__hover-backplate {
          @apply opacity-100;
        }
      }
      &#{$root}__image-wrapper_active {
        #{$root}__image {
          transform: scale(1.3);
        }
        ~ #{$root}__hover-backplate {
          @apply opacity-100;
        }
      }
    }*/
  }
  &__image {
    @apply w-full h-full object-cover  transition duration-200 relative;
  }
  &__indicator {
    &_left {
      top: -4%;
      left: -4%;
    }
    &_right {
      top: -4%;
      right: -4%;
    }
    &_left-bottom {
      bottom: -4%;
      left: -4%;
    }
    &_right-bottom {
      bottom: -4%;
      right: -4%;
    }
  }
  &Indicator {
    @apply absolute;
    width: calc(100% / 3);
    height: calc(100% / 3);
    min-width: 14px;
    min-height: 14px;
    &:before {
      @apply absolute bg-white rounded-full;
      content: '';
      width: 112%;
      left: -6%;
      top: -6%;
      height: 112%;
    }
    &_new-message {
      &:before {
        content: none;
      }
    }
    &__content {
      @apply w-full h-full relative rounded-full;
    }
  }
}
</style>
